export const VIMEO_PATTERNS = {
  // Pure numeric ID pattern
  numericId: /^\d+$/,

  // Vimeo URL pattern that captures the video ID
  vimeoUrl: /^(?:https?:\/\/)?(?:www\.)?vimeo\.com\/(?:manage\/videos\/)?(\d+)(?:\?.*)?$/,
} as const;

export function isValidVimeoValue(value: string): boolean {
  if (!value || value.trim() === "") return false;

  const trimmed = value.trim();

  if (VIMEO_PATTERNS.numericId.test(trimmed)) {
    return true;
  }

  return VIMEO_PATTERNS.vimeoUrl.test(trimmed);
}

export function extractVimeoId(value: string): string {
  if (!isValidVimeoValue(value)) return value;

  const trimmed = value.trim();

  if (VIMEO_PATTERNS.numericId.test(trimmed)) {
    return trimmed;
  }

  const match = trimmed.match(VIMEO_PATTERNS.vimeoUrl);

  if (match && match[1]) {
    return match[1];
  }

  return value;
}

export function validateVimeoValue(value: string, t: (key: { id: string }) => string): string | undefined {
  if (!isValidVimeoValue(value)) {
    return t({ id: "invalidVimeoFormat" });
  }

  return undefined;
}